// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IOfferFromHistoryFeaturesSchema } from './OfferFromHistoryFeaturesSchema';
import type { IPricesSchema } from './PricesSchema';

export interface IOfferFromHistoryResponseV2Schema {
  /** Адрес объявления **/
  address?: string;
  /** Условия сделки **/
  dealConditions?: IOfferFromHistoryFeaturesSchema[];
  /** Список параметров объекта **/
  features: IOfferFromHistoryFeaturesSchema[];
  /** Список урлов с фотографиями из объявления **/
  images?: string[];
  /** Название коттеджного поселка **/
  kpName?: string;
  /** Ссылка на объявление (только path часть) **/
  link?: string;
  /** Данные о ценах **/
  prices: IPricesSchema;
  /** Статус публикации объявления (активное/неактивное) **/
  status: EStatus;
  /** Заголовок для объявления Н-р: 35 м² · 1-комн. · 3/16 этаж **/
  title: string;
}
export enum EStatus {
  /** Снято с публикации **/
  'Deactivated' = 'deactivated',
  /** Опубликовано **/
  'Published' = 'published',
}
